import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import HeadingComp from '../Components/HeadingComp'

const TermsPage = () => {
  return (
    <div>
      <Navbar />

      <div>
        <div className='w-full max-w-[1212px] max_xl1460:max-w-[980px] max_1024:px-10 max_500:px-5 m-auto my-[100px] max_500:my-[50px] max_768:my-[60px]'>
          <HeadingComp head1="Terms and Conditions" head2="" />
          <p className='Text18Sans mt-[30px] max_500:mt-5'>Welcome to <span className='font-medium'>Trisol Lubricants!</span> By engaging with us, using our services, or submitting your details through our Facebook Instant Form or other platforms, you agree to comply with the following terms and conditions. Please read them carefully.
          </p>


          <div className='flex flex-col gap-10 max_500:gap-6 mt-[30px] max_1024:mt-5 '>
            {/* 1st  */}
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>1. Use of Services</h3>
              <div className='flex flex-col mt-2 ml-4 max_500:ml-2'>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>Our services are intended for individuals, dealers, and distributors interested in our lubricants and related products.</p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>By submitting your details, you confirm that the information provided is accurate and complete.
                  </p>
                </div>
              </div>
            </div>

            {/* 2 nd */}
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>2. Privacy
              </h3>
              <div className='flex flex-col mt-2 ml-4 max_500:ml-2'>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>Our services are intended Any information you provide will be handled according to our <span className='font-semibold'>Privacy Policy.</span></p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>We are committed to protecting your personal information and using it only for purposes such as responding to inquiries, providing services, and marketing communication.</p>
                </div>
              </div>
            </div>

            {/* 3rd */}
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>3. Communication</h3>
              <div className='flex flex-col mt-2 ml-4 max_500:ml-2'>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>By submitting your contact information, you consent to receive communication from <span className='font-semibold'>Trisol Lubricants</span> via phone, email, or SMS regarding our products, services, or updates.</p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>You can opt out of receiving marketing communication at any time by contacting us directly.
                  </p>
                </div>
              </div>
            </div>
            {/* 4 th */}
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>4. Intellectual Property</h3>
              <div className='flex flex-col mt-2 ml-4 max_500:ml-2'>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>All content, logos, and trademarks used by <span className='font-semibold'>Trisol Lubricants</span> are the property of the company. You may not copy, reproduce, or use this content without prior written permission.</p>
                </div>
              </div>
            </div>


            {/* 5 th */}
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>5. Limitation of Liability</h3>
              <div className='flex flex-col mt-2 ml-4 max_500:ml-2'>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'><span className='font-semibold'>Trisol Lubricants</span> is not liable for any direct, indirect, incidental, or consequential damages arising from the use of our products or services unless explicitly stated in a written agreement.
                  </p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>Users must ensure that the products are used according to the guidelines provided.</p>
                </div>
              </div>
            </div>


            {/* 6 th */}
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>6. Changes to Terms</h3>
              <div className='flex flex-col mt-2 ml-4 max_500:ml-2'>
              <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'><span className='font-semibold'>Trisol Lubricants</span>  reserves the right to update or modify these terms and conditions at any time without prior notice. Continued use of our services implies acceptance of the updated terms.

                  </p>
                </div>
              </div>
            </div>
            {/* 7 th */}
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>7. Governing Law
              </h3>
              <div className='flex flex-col mt-2 ml-4 max_500:ml-2'>
              <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'>These terms and conditions are governed by the laws of India. Any disputes arising from these terms will be subject to the jurisdiction of courts located in <span className='font-semibold'>Surat, Gujarat.</span>

                  </p>
                </div>
              </div>
            </div>
            {/* 8 th */}
            <div>
              <h3 className='text-[24px] max_xl1460:text-[22px] font-MontserratF font-semibold '>8. Contact Us</h3>
              <p className='Text18Sans mt-3 max_500:mt-[6px]'> If you have any questions or concerns about these Terms and Conditions, please contact us:</p>
              <h3 className='text-[22px] max_xl1460:text-[20px] font-MontserratF font-medium mt-2'>Trisol Lubricants</h3>
              <div className='flex flex-col mt-2 ml-4 max_500:ml-2'>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'><span className='font-medium'>Phone:</span><a href='tel:6354527074'>+91 63545 27074</a>
                  </p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'><span className='font-medium'>Email:</span> Trisol@gmail.com
                  </p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'><span className='font-medium'>Website:</span> <a href='https://www.trisollubricant.com/' className='text-[#1155cc]'>www.trisollubricant.com</a>
                  </p>
                </div>
                <div className='flex gap-2 items-start'>
                  <div className='w-2 h-2 max_500:w-[6px] max_500:h-[6px] rounded-full bg-black mt-2'></div>
                  <p className='Text18Sans w-[calc(100%-20px)]'><span className='font-medium'>Address:</span> Block No. E-37, Hindva Dreams, Dhoran Pardi Gaypagla Road, Kamrej, Surat, Gujarat-394155
                  </p>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default TermsPage
